import { createActionGroup, props } from '@ngrx/store';

import { RebootBoxCommand } from '../../models/BoxGateway';
import { DeviceId } from '../../models/Device';
import { Execution } from '../../models/Execution';

export const BoxActions = createActionGroup({
    source: 'Box',
    events: {
        boxRebootRequested: props<{
            deviceId: DeviceId;
        }>(),
        boxRebootStarted: props<{
            command: RebootBoxCommand;
            pendingTask: Execution;
        }>(),
    },
});
